var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLongRight = function SvgArrowLongRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 16,
    fill: "none",
    viewBox: "0 0 45 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m35.486.5-1.51 1.175 5.77 4.492H.16V7.83h39.585l-5.77 4.492 1.51 1.179 8.352-6.502z"
  })));
};
export default SvgArrowLongRight;